import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { mockClaimConversation } from 'app/mocks/factories/claims/mock-conversation';
import { mockClaimConversationMetadata } from 'app/mocks/factories/claims/mock-conversation-metadata';
import { mockCreateMessage } from 'app/mocks/factories/claims/mock-create-message';
import { mockSyncConversation } from 'app/mocks/factories/claims/mock-sync-conversation';
import { mockUpdateMessage } from 'app/mocks/factories/claims/mock-update-message';
import { MockHttpInterceptor } from 'app/mocks/http-mock.interceptor';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';
import { environment } from 'environments/environment';

export type MockFactory = (
    apiEndpointService: ApiEndpointService,
    interceptor?: MockHttpInterceptor,
) => IMockRegistry;

export const mockRegistryFactories: MockFactory[] = [
    environment.feature.claims.messenger ? mockClaimConversationMetadata : null,
    environment.feature.claims.messenger ? mockClaimConversation : null,
    environment.feature.claims.messenger ? mockCreateMessage : null,
    environment.feature.claims.messenger ? mockUpdateMessage : null,
    environment.feature.claims.messenger ? mockSyncConversation : null,
].filter(Boolean);
